import {
	GET_SSID_TEMPLATE_LIST,
	GET_SSID_TEMPLATE_SUCCESS,
	GET_SSID_TEMPLATE_FAIL,
	ADD_SSID_TEMPLATE,
	ADD_SSID_TEMPLATE_COMPLETE,
	EDIT_SSID_TEMPLATE,
	EDIT_SSID_TEMPLATE_COMPLETE,
	RESET_SSID_TEMPLATE_ADD,
	DELETE_SSID_TEMPLATE,
	DELETE_SSID_TEMPLATE_COMPLETE,
	RESET_SSID_TEMPLATE_DELETE,
} from '../../constants/ssid/ssidConstants';

/**
 * Reducer function for managing ssid list state.
 *
 * This reducer handles actions related to fetching ssid data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the ssid list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const SsidTemplateListReducer = (
	state = {
		ssidTemplateList: {},
		addSSIDTemplateData: null,
		loadingAdd: false,
		deleteSSIDTemplateData: null,
		loadingDelete: false,
	},
	action
) => {
	switch (action.type) {
		case GET_SSID_TEMPLATE_LIST:
			return {
				...state,
				loading: true,
			};
		case GET_SSID_TEMPLATE_SUCCESS:
			return {
				...state,
				loading: false,
				ssidTemplateList: action.payload,
			};
		case GET_SSID_TEMPLATE_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case ADD_SSID_TEMPLATE:
		case EDIT_SSID_TEMPLATE:
			return {
				...state,
				loadingAdd: true,
			};
		case ADD_SSID_TEMPLATE_COMPLETE:
		case EDIT_SSID_TEMPLATE_COMPLETE:
			return {
				...state,
				loadingAdd: false,
				addSSIDTemplateData: action.payload,
			};
		case RESET_SSID_TEMPLATE_ADD:
			return {
				...state,
				loadingAdd: false,
				addSSIDTemplateData: null,
			};
		case DELETE_SSID_TEMPLATE:
			return {
				...state,
				loadingDelete: true,
			};
		case DELETE_SSID_TEMPLATE_COMPLETE:
			return {
				...state,
				loadingDelete: false,
				deleteSSIDTemplateData: action.payload,
			};
		case RESET_SSID_TEMPLATE_DELETE:
			return {
				...state,
				loadingDelete: false,
				deleteSSIDTemplateData: null,
			};
		default:
			return state;
	}
};
// export const ssidTriggerReducer = (
// 	state = { ssidAddTrigger: false },
// 	action
// ) => {
// 	switch (action.type) {
// 		case SSID_ADD_TRIGGER:
// 			return {
// 				...state,
// 				ssidAddTrigger: action.payload,
// 			};
// 		case SHOW_SSID_MODAL:
// 			return {
// 				...state,
// 				...action.payload,
// 			};
// 		default:
// 			return state;
// 	}
// };
